<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        storedFilmTypes.length > 0 ? 'selected' : ''
      ]"
      @click="form.showFilmTypeModal = true"
    >
      Film type
    </button>
    <b-modal
      v-model="form.showFilmTypeModal"
      :no-close-on-backdrop="true"
      size="sm"
      body-class="filmtypemodal"
      title="Film types"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveFilmtype"
    >
      <b-form-group>
        <b-form-checkbox
          v-model="allIsSelected"
          class="centerlabelandformgroup"
          @change="selectAll"
        >
          {{ allIsSelected ? "Unselect all" : "Select all" }}
        </b-form-checkbox>
        <b-form-checkbox-group
          v-model="chosenFilmTypes"
          :options="form.options"
          stacked
          class="centerlabelandformgroup"
        />
      </b-form-group>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
export default {
    name: "FilmTypeModal",
    props: {
        form: Object,
    },
    data() {
      return {
        selected: [], // Must be an array reference!
        allIsSelected: false,
        chosenFilmTypes: []
      };
    },
    computed:{
        storedFilmTypes() {
            return this.$store.getters["campaignApiBody/getPayload"].filmTypes
        }
    },
    methods: {
      onKeyUp(event) {
        if (event.key === "Enter" && this.form.showFilmTypeModal) {
          this.saveFilmtype();
          this.form.showFilmTypeModal = false;
        }
      },
      popupIsShown() {
        let query = this.$store.getters['campaignApiBody/getPayload'];
        if (query.filmTypes) {
          this.chosenFilmTypes = query.filmTypes;
        } else this.chosenFilmTypes = [];
        document.addEventListener("keyup", this.onKeyUp);
        if (this.chosenFilmTypes.length === 3) this.allIsSelected = true;
        else if (this.chosenFilmTypes.length === 0) this.allIsSelected = false;
      },
      popupIsHidden() {
        document.removeEventListener("keyup", this.onKeyUp);
      },
      selectAll(checked) {
        if (checked) {
          this.chosenFilmTypes = [
            ...this.form.options.map(opt => opt.value)
          ];
        } else {
          this.chosenFilmTypes = [];
        }
      },
      saveFilmtype() {
        const payload = {
          ...this.$store.getters['campaignApiBody/getPayload'],
          filmTypes: this.chosenFilmTypes
        };
        this.$store.commit(
          'campaignApiBody/updatePayload',
          payload,
        );      
      }
    }
  };
  </script>
<style scoped>
>>> .filmtypemodal {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.centerlabelandformgroup {
    width: 8rem;
    margin-left: 4rem;
}
>>> .custom-control {
    display: flex;
}
>>> .custom-control label {
    display: flex;
    align-items: center;
}
</style>
  